import React, { useState, useEffect, useRef } from "react";
import Header from "../Header";
import Footer from "../Footer";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import $ from "jquery";
import "datatables.net-bs5";
import Swal from "sweetalert2";
import config from "../common/Config";
import { Link } from "react-router-dom";
import Select from "react-select";

const progressStyles = `
  <style>
    .progress-container {
      display: inline-block;
      vertical-align: middle;
    }
    .progress {
      background-color: #f8f9fa;
      border-radius: 4px;
      overflow: hidden;
    }
    .progress-bar {
      transition: width 0.3s ease;
      font-size: 10px;
      line-height: 20px;
      color: white;
      text-align: center;
    }
    .btn-sm {
      padding: 0.25rem 0.5rem;
      font-size: 0.875rem;
      border-radius: 0.2rem;
    }
  </style>
`;

if (!document.getElementById('catalogue-progress-styles')) {
  const styleElement = document.createElement('div');
  styleElement.id = 'catalogue-progress-styles';
  styleElement.innerHTML = progressStyles;
  document.head.appendChild(styleElement);
}

const CatalogueNew = () => {
  const [draw, setDraw] = useState(1);
  const [start, setStart] = useState(0);
  const [length, setLength] = useState(50);
  const [brandList, setBrandList] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [productsSelected, setProductsSelected] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [productType, setProductType] = useState("");
  const [hideProducts, setHideProducts] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [catalogueStatus, setCatalogueStatus] = useState({});
  const [generatingCatalogues, setGeneratingCatalogues] = useState(new Set());

  const pollingIntervalsRef = useRef(new Map());
  const tableRef = useRef(null);
  const accessToken = localStorage.getItem("accessToken");
  const API_BASE_URL = "http://localhost:5000/api/v1";
  const API_BASE_URL_PDF = "http://localhost:5000/output";
  const token = localStorage.getItem("token");

  const fetchCatalogueList = async () => {
    const brandForm = new FormData();
    brandForm.append("draw", draw);
    brandForm.append("start", start);
    brandForm.append("length", length);

    const apiBrandUrl = `${config.API_URL}/ws-catalog-list`;
    try {
      const response = await fetch(apiBrandUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: brandForm,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch brand list");
      }

      const data = await response.json();
      setBrandList(data.data);
    } catch (error) {
      console.log("Error fetch brand list", error);
    }
  };

  const fetchProductList = async () => {
    setProductOptions([]);
    const Url = `${config.API_URL}/get-product`;
    try {
      const response = await fetch(Url, {
        method: "GET",
        headers: {
          authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      const formattedOptions = data.map((item) => ({
        label: item.name + "(" + item.code + ")",
        value: item.id,
      }));
      setProductOptions(formattedOptions);
    } catch (error) {
      console.error("api fail error fetching products");
    }
  };

  const fetchCategoryList = async () => {
    setProductOptions([]);
    const Url = `${config.API_URL}/get-category`;
    try {
      const response = await fetch(Url, {
        method: "GET",
        headers: {
          authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      const formattedOptions = data.map((item) => ({
        label: item.name,
        value: item.id,
      }));
      setProductOptions(formattedOptions);
    } catch (error) {
      console.error("api fail error fetching products category wise");
    }
  };

  const fetchBrandList = async () => {
    setProductOptions([]);
    const Url = `${config.API_URL}/get-brands`;
    try {
      const response = await fetch(Url, {
        method: "GET",
        headers: {
          authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      const formattedOptions = data.map((item) => ({
        label: item.name,
        value: item.id,
      }));
      setProductOptions(formattedOptions);
    } catch (error) {
      console.error("api fail error fetching products brand wise");
    }
  };

  const fetchPromotedProductList = async () => {
    setProductOptions([]);
    const Url = `${config.API_URL}/get-promoted-product`;
    try {
      const response = await fetch(Url, {
        method: "GET",
        headers: {
          authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      const formattedOptions = data.map((item) => ({
        label: item.name,
        value: item.id,
      }));
      setProductOptions(formattedOptions);
    } catch (error) {
      console.error("api fail error fetching promoted products");
    }
  };

  const isNotToday = (rowDate) => {
    const today = new Date().toISOString().split("T")[0];
    return rowDate !== today;
  };

  const pollCatalogueStatus = async (brochureId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/catalogue/status/${brochureId}`, {
        method: "GET",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch status");
      }

      const data = await response.json();

      if (data.success) {
        setCatalogueStatus(prev => ({
          ...prev,
          [brochureId]: data
        }));

        if (data.status === 'completed' || data.status === 'failed') {
          setGeneratingCatalogues(prev => {
            const newSet = new Set(prev);
            newSet.delete(brochureId);
            return newSet;
          });

          const interval = pollingIntervalsRef.current.get(brochureId);
          if (interval) {
            clearInterval(interval);
            pollingIntervalsRef.current.delete(brochureId);
          }

          if (data.status === 'completed') {
            fetchCatalogueList();
          }
        }
      }
    } catch (error) {
      console.error("Error polling status:", error);
    }
  };

  const startPolling = (brochureId) => {
    if (pollingIntervalsRef.current.has(brochureId)) {
      return;
    }

    const interval = setInterval(() => pollCatalogueStatus(brochureId), 2000);
    pollingIntervalsRef.current.set(brochureId, interval);
  };

  const retryCatalogue = async (brochureId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/catalogue/retry/${brochureId}`, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (data.success) {
        setGeneratingCatalogues(prev => new Set(prev).add(brochureId));
        startPolling(brochureId);
      }
    } catch (error) {
      console.error("Error retrying catalogue:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to retry catalogue generation.",
        icon: "error",
      });
    }
  };



  const initializeDataTable = () => {
    if (tableRef.current) {
      tableRef.current.destroy();
    }

    const table = $("#neworderTable").DataTable({
      pageLength: 50,
      paging: true,
      lengthMenu: [10, 20, 50],
      searching: true,
      ordering: false,
      info: true,
      responsive: true,
      autoWidth: false,
      language: {
        paginate: {
          first: "First",
          last: "Last",
          next: "Next",
          previous: "Previous",
        },
        search: "Search:",
      },
      data: brandList,
      columns: [
        {
          data: null,
          className: "text-center",
          width: "5%",
          render: function (data, type, row, meta) {
            return meta.row + meta.settings._iDisplayStart + 1;
          },
        },
        {
          data: "date",
          className: "text-start",
          width: "10%",
          render: function (data, type, row) {
            const checkIsNotToday = () => {
              const [day, month, year] = data.split("-");
              const formattedRowDate = `20${year}-${month.padStart(
                2,
                "0"
              )}-${day.padStart(2, "0")}`;
              const today = new Date().toISOString().split("T")[0];
              return formattedRowDate !== today;
            };

            if (checkIsNotToday()) {
              return `<span style="color: red;">${data}</span>`;
            } else {
              return data;
            }
          },
        },
        {
          data: "ref_num",
          className: "text-start",
          width: "15%"
        },
        {
          data: "pdf_file",
          className: "text-start",
          width: "30%",
          render: function (data, type, row) {
            if (!data) return '';
            const filename = data.split('/').pop();
            const nameWithoutExtension = filename.replace(/\.[^/.]+$/, '');
            return nameWithoutExtension;
          }
        },
        {
          data: "code",
          className: "text-center",
          width: "20%",
          render: function (data, type, row) {
            const checked = row.status == "1" ? "checked" : "";
            return `
          <label class="switch" style="margin: 0px auto;">
          <input data-id="${row.id}" class="switch-input" type="checkbox" name="changeStatus" id="changeStatus_${row.id}" ${checked} />
          <span class="switch-label" data-on="Active" data-off="Inactive"></span>
          <span class="switch-handle"></span>
          </label>`;
          },
        },
        {
          data: "code",
          className: "text-center",
          width: "20%",
          render: function (data, type, row) {
            if (!row.pdf_file) {
              if (row.status == "0") {
                return ``;
              }
              // console.log(generatingCatalogues);

              const isGenerating = generatingCatalogues.has(row.id);
              const status = catalogueStatus[row.id];

              if (isGenerating) {
                return `
                <div class="progress-container" style="width: 100px; margin: 0 auto;">
                  <div class="progress" style="height: 20px;">
                    <div class="progress-bar progress-bar-striped progress-bar-animated" 
                         role="progressbar" 
                         style="width: ${status?.progress || 0}%; background-color: #007bff;">
                      ${status?.progress || 0}%
                    </div>
                  </div>
                </div>
                `;
              } else if (status && status.status === 'failed') {
                return `
                <button class="btn btn-danger btn-sm" onclick="window.retryCatalogue('${row.id}')" title="Retry Generation">
                  <i class="fa fa-refresh"></i> Retry
                </button>
                `;
              } else if (!isNotToday(row.date)) {
                return `
                <button class="btn btn-loading btn-sm" disabled>
                <i class="fa fa-spinner fa-spin"></i> Loading...
                </button>
                `;
              } else {
                return ` `;
              }
            } else {
              const fileUrl = `${API_BASE_URL_PDF}/${row.pdf_file}`;
              return `
              <a href="${fileUrl}" target="_blank" download class="btn btn-sm" title="Download PDF">
              <i class="fa fa-download"></i> Download
              </a>
              `;
            }
          },
        },
      ],
      columnDefs: [],
      initComplete: function () {
        this.api().columns.adjust().draw();
      },
      // drawCallback: function () {
      //   this.api().columns.adjust().draw();
      // }
    });

    $("#neworderTable")
      .off("change", ".switch-input")
      .on("change", ".switch-input", function (event) {
        const id = $(this).data("id");
        const status = this.checked ? 1 : 0;
        handleChangeStatus(id, status);
      });

    tableRef.current = table;
  };

  useEffect(() => {
    window.retryCatalogue = retryCatalogue;
    return () => {
      delete window.retryCatalogue;
    };
  }, []);

  useEffect(() => {
    if (brandList.length > 0) {
      initializeDataTable();
    }
  }, [brandList, generatingCatalogues, catalogueStatus]);

  useEffect(() => {
    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }

    fetchCatalogueList();
  }, [accessToken]);

  useEffect(() => {
    setHideProducts(true);
    if (productType === "products") {
      fetchProductList();
    } else if (productType === "categories") {
      fetchCategoryList();
    } else if (productType === "brands") {
      fetchBrandList();
    } else if (productType === "new_arrivals") {
      setProductOptions([]);
      setHideProducts(false);
    } else if (productType === "promoted") {
      fetchPromotedProductList();
    }
  }, [productType]);

  const changeProductType = (e) => {
    const value = e.target.value;
    setProductType(value);
  };

  const specialOptions = [
    { label: "Select All", value: "select_all" },
    { label: "Remove All", value: "remove_all" },
  ];

  const handleChange = (selected) => {
    const selectedOptions = selected || [];
    const lastSelected = selectedOptions[selectedOptions.length - 1];

    if (lastSelected?.value === "select_all") {
      setSelectedOptions(productOptions);
      setProductsSelected(productOptions);
    } else if (lastSelected?.value === "remove_all") {
      setSelectedOptions([]);
      setProductsSelected([]);
    } else {
      setSelectedOptions(selectedOptions);
      setProductsSelected(selectedOptions);
    }
  };

  const submitCatalogue = async () => {
    const form = document.getElementById("createCatalogue");
    const formdata = new FormData(form);

    const productTypeValue = formdata.get("option");
    const packsize = formdata.get("packsize");
    const typePriceValue = formdata.get("type_price");
    const sizeOptionValue = formdata.get("size_options");
    const dateValue = formdata.get("date");
    const bannerImage = formdata.get("banner");

    const productValues = productsSelected.map((product) => product.value);

    if (!productTypeValue) {
      Swal.fire({ icon: "warning", text: "Please select Product Type." });
      return;
    }
    if (!packsize) {
      Swal.fire({ icon: "warning", text: "Please select Packsize." });
      return;
    }
    if (!typePriceValue) {
      Swal.fire({ icon: "warning", text: "Please select Price." });
      return;
    }
    if (!sizeOptionValue) {
      Swal.fire({ icon: "warning", text: "Please select Size." });
      return;
    }
    if (!bannerImage) {
      Swal.fire({ icon: "warning", text: "Please upload Front Page (A4)." });
      return;
    }
    if (!dateValue) {
      Swal.fire({ icon: "warning", text: "Please select Catalogue Date." });
      return;
    }
    if (hideProducts && (!productsSelected || productsSelected.length === 0)) {
      Swal.fire({
        icon: "warning",
        text: "Please select at least one Product.",
      });
      return;
    }
    fetchCatalogueList();
    setIsSubmitting(true);

    formdata.append("productlist", productValues.join(','));

    try {
      const response = await fetch(`${API_BASE_URL}/catalogue/create`, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formdata,
      });

      const data = await response.json();

      if (data.success) {
        Swal.fire({
          title: "Success!",
          text: data.message || "Your catalogue will be generated shortly.",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
          timerProgressBar: true,
        });

        const brochureId = data.brochure_id;
        setGeneratingCatalogues(prev => new Set(prev).add(brochureId));
        startPolling(brochureId);

        form.reset();
        setProductsSelected([]);
        setSelectedOptions([]);
        setProductType("");
        const modalElement = document.getElementById('create-catalogue');
        if (modalElement) {
          const closeButton = modalElement.querySelector('[data-bs-dismiss="modal"]');
          if (closeButton) {
            closeButton.click();
          }
        }
      } else {
        throw new Error(data.message || "Failed to create catalogue");
      }
    } catch (error) {
      console.error("API failed when submitting catalogue:", error);
      Swal.fire({
        title: "Error",
        text: error.message || "There was an error submitting the catalogue. Please try again later.",
        icon: "error",
        showConfirmButton: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChangeStatus = async (id, status) => {
    const formData = new FormData();
    formData.append("id", id);
    formData.append("status", status);
    const apiUrl = `${config.API_URL}/update_catalogs_status`;
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to change status");
      }

      const data = await response.json();

      Swal.fire({
        title: "Success",
        text: "Status changed successfully.",
        icon: "success",
        showConfirmButton: false,
        timer: 1500,
      });

      fetchCatalogueList();
    } catch (error) {
      console.error("Error status change:", error);
    }
  };

  useEffect(() => {
    return () => {
      pollingIntervalsRef.current.forEach((interval) => {
        clearInterval(interval);
      });
      pollingIntervalsRef.current.clear();

      if (tableRef.current) {
        tableRef.current.destroy();
      }
    };
  }, []);

  return (
    <div>
      <div className="modal fade" id="create-catalogue" tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Create Catalogue</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="catalogue-popup">
                <form id="createCatalogue">
                  <div className="row mb-3 padd-l-13px">
                    <label htmlFor="desc" className="col-sm-3 col-form-label">
                      Product Type <span style={{ color: "red" }}>*</span>:
                    </label>
                    <div className="col-sm-9">
                      <ul>
                        <li>
                          <input
                            type="radio"
                            name="option"
                            value="products"
                            checked={productType === "products"}
                            onChange={changeProductType}
                          />
                          <label className="form-check-label">
                            Products Wise
                          </label>
                        </li>
                        <li>
                          <input
                            type="radio"
                            name="option"
                            value="categories"
                            checked={productType === "categories"}
                            onChange={changeProductType}
                          />
                          <label className="form-check-label">
                            Categories Wise
                          </label>
                        </li>
                        <li>
                          <input
                            type="radio"
                            name="option"
                            value="brands"
                            checked={productType === "brands"}
                            onChange={changeProductType}
                          />
                          <label className="form-check-label">
                            Brands Wise
                          </label>
                        </li>
                        <li>
                          <input
                            type="radio"
                            name="option"
                            value="promoted"
                            checked={productType === "promoted"}
                            onChange={changeProductType}
                          />
                          <label className="form-check-label">
                            Promoted Wise
                          </label>
                        </li>
                        <li>
                          <input
                            type="radio"
                            name="option"
                            value="new_arrivals"
                            checked={productType === "new_arrivals"}
                            onChange={changeProductType}
                          />
                          <label className="form-check-label">
                            New Arrivals
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <hr />
                  <div className="row mb-3 padd-l-13px">
                    <label htmlFor="desc" className="col-sm-3">
                      &nbsp;
                    </label>
                    <div className="col-sm-9">
                      <div>
                        <label className="checkbox">
                          <input
                            type="checkbox"
                            name="packsize"
                            defaultChecked
                            readOnly
                          />
                          <span className="default"></span>
                        </label>
                        <label className="form-check-label">
                          Pack size
                        </label>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="row mb-3 padd-l-13px">
                    <label htmlFor="desc" className="col-sm-3 col-form-label">
                      Price <span style={{ color: "red" }}>*</span>:
                    </label>
                    <div className="col-sm-9">
                      <ul>
                        <li>
                          <input
                            type="radio"
                            name="type_price"
                            value="box_price"
                          />
                          <label className="form-check-label">
                            Box Price
                          </label>
                        </li>
                        <li>
                          <input
                            type="radio"
                            name="type_price"
                            value="piece_price"
                          />
                          <label className="form-check-label">
                            Piece Price
                          </label>
                        </li>
                        <li>
                          <input
                            type="radio"
                            name="type_price"
                            value="both"
                          />
                          <label className="form-check-label">
                            Both
                          </label>
                        </li>
                        <li>
                          <input
                            type="radio"
                            name="type_price"
                            value="no_price"
                          />
                          <label className="form-check-label">
                            No Price
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <hr />
                  <div className="row mb-3 padd-l-13px">
                    <label htmlFor="desc" className="col-sm-3 col-form-label">
                      Size <span style={{ color: "red" }}>*</span>:
                    </label>
                    <div className="col-sm-9">
                      <ul>
                        <li>
                          <input
                            type="radio"
                            name="size_options"
                            value="3"
                            defaultChecked
                            readOnly
                          />
                          <label className="form-check-label">
                            4 X 4
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="row mb-3 padd-l-13px">
                    <label htmlFor="desc" className="col-sm-3 col-form-label">
                      Front Page (A4) <span style={{ color: "red" }}>*</span>:
                    </label>
                    <div className="col-sm-9">
                      <input
                        className="form-control"
                        type="file"
                        name="banner"
                        accept="image/*"
                      />
                    </div>
                  </div>

                  <div className="row mb-3 padd-l-13px">
                    <label htmlFor="desc" className="col-sm-3 col-form-label">
                      Catalogue Date <span style={{ color: "red" }}>*</span>:
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="date"
                        name="date"
                        className="form-control"
                        defaultValue={new Date().toISOString().split("T")[0]}
                      />
                    </div>
                  </div>

                  {hideProducts && (
                    <div className="row mb-3 padd-l-13px">
                      <label htmlFor="desc" className="col-sm-3 col-form-label">
                        Select Product <span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="col-sm-9">
                        <Select
                          isMulti
                          options={[...specialOptions, ...productOptions]}
                          value={selectedOptions}
                          onChange={handleChange}
                          closeMenuOnSelect={false}
                          placeholder="Select products..."
                        />
                      </div>
                    </div>
                  )}

                  <hr />
                  <div className="form-group">
                    <button
                      type="button"
                      className="float-right-btn common-popup-btn"
                      onClick={submitCatalogue}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Creating..." : "Create Catalogue"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Header />
      <nav className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <a href="#">
                <i className="fa fa-home"></i>
              </a>
              <span className="last-crumb">Catalogue</span>
            </div>
          </div>
        </div>
      </nav>
      <div className="main-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <div style={{ float: "right" }}>
                <button
                  type="button"
                  className="create-catalogue-btn"
                  data-bs-toggle="modal"
                  data-bs-target="#create-catalogue"
                >
                  Create Catalogue
                </button>
              </div>

              <div
                className="show-order-area dashboard"
                style={{ position: "relative" }}
              >
                <div
                  className="verical-scrl-wrapper common-table catalogue-tbl"
                  id="style-3"
                >
                  <table
                    className="table table-bordered dataTable resizable"
                    id="neworderTable"
                  >
                    <thead>
                      <tr>
                        <th style={{ width: "5%" }}>Sr No.</th>
                        <th style={{ width: "10%" }}>Date</th>
                        <th style={{ width: "15%" }}>Reference No</th>
                        <th style={{ width: "30%" }}>Catalogue Name</th>
                        <th style={{ width: "20%" }}>Status</th>
                        <th style={{ width: "20%" }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    
    </div>
  );
};

export default CatalogueNew;